import * as React from 'react';
import PropTypes from 'prop-types';

import {SVGIcon} from '@homeaway/react-svg';
import {CHECK__16} from '@homeaway/svg-defs';

function FlagsMenu({flags}) {
    return (
        <div className="site-header-tray__menu site-header-tray__drawer">
            <div className="site-header-tray__menu-items">
                {flags.items.map((item, i) => (
                    <a className={`site-header-tray__menu-item-link site-header-tray__menu-item-link--icon-right site-header-tray__menu-item-link--flag ${item.countryCode}`} data-bypass="true" href={item.link} key={`${item.countryCode}-${item.link}`}>
                        <span>
                            <i aria-hidden="true" className={`site-header-tray__menu-item-icon flag-${item.countryCode}`} />
                            <span className="site-header-tray__menu-item-text">{item.text}</span>
                        </span>
                        {i === 0 &&
                            <SVGIcon className="text-brand" inline markup={CHECK__16} />
                        }
                    </a>
                ))}
            </div>
        </div>
    );
}

FlagsMenu.propTypes = {
    flags: PropTypes.shape({})
};

export {FlagsMenu};
